export const  style = {
      
    minWidth: '300px',
    minHeight: '55px',
    border: '1px solid #34D298',
    padding: '16px',
    color: '#fff',
    fontWeight:"600",
    background: '#000',
    zIndex:"99999"
    
}

export const iconTheme = {
    primary: '#000',
    secondary: '#fff',
}

export const  position= {
    position: "top-center"
}


export const  zindex= {
    zIndex: "99999"
}